import Hero from "@/components/Hero";
import StatsBar from "@/components/StatsBar";
import Reinvention from "@/components/Reinvention";
import ServicesGrid from "@/components/ServicesGrid";
import Partners from "@/components/Partners";
import Pricing from "@/components/Pricing";
import CaseStudies from "@/components/CaseStudies";
import WhyChoose from "@/components/WhyChoose";
import Testimonials from "@/components/Testimonials";
import LeadMagnet from "@/components/LeadMagnet";
import SEO from "@/components/SEO";
import {
  ORGANIZATION_SCHEMA,
  LOCAL_BUSINESS_SCHEMA,
  WEBSITE_SCHEMA,
} from "@/lib/seoSchemas";

const HOME_JSONLD = {
  "@context": "https://schema.org",
  "@graph": [ORGANIZATION_SCHEMA, LOCAL_BUSINESS_SCHEMA, WEBSITE_SCHEMA],
};

const Home = () => {
  return (
    <div data-testid="page-home">
      <SEO
        title="Conciergerie Airbnb Bretagne, Côte d'Émeraude & Morbihan"
        description="Conciergerie Airbnb premium en Bretagne : Saint-Malo, Dinard, Cancale, Dinan, Damgan, La Roche-Bernard. Deux équipes locales, commission 15%, 24h/24 · 7j/7, +30% de revenus. Étude gratuite 24h."
        keywords="conciergerie Airbnb Bretagne, conciergerie Saint-Malo, conciergerie Dinard, conciergerie Cancale, conciergerie Côte d'Émeraude, conciergerie Morbihan, conciergerie Damgan, conciergerie La Roche-Bernard, location courte durée Bretagne"
        jsonLd={HOME_JSONLD}
        breadcrumbs={[{ name: "Accueil", path: "/" }]}
      />
      <Hero />
      <StatsBar />
      <Reinvention />
      <ServicesGrid />
      <Partners />
      <Pricing />
      <CaseStudies />
      <WhyChoose />
      <LeadMagnet />
      <Testimonials />
    </div>
  );
};

export default Home;
